const ControlVideos = function () {

    const playVideo = () => {

        const btPlay = $('.bt-play-video');

        btPlay.each(function(e){

            const el = $(this);
            
            if($(window).width() < 992){
                setTimeout(() => {
                    el.trigger('click');//play
                    el.trigger('click');//pause
                }, 50);
            }

            el.on('click', function(){
                let idToPlay = $(this).attr('data-toplay');
                let vid = document.getElementById(idToPlay); 

                
                if(!$(this).hasClass('play-started')){
                    playJs(vid);
                } else {
                    pauseJs(vid);
                }
                
                $(this).toggleClass('play-started');

            })

        })

    }

    const playJs = (el) => {
        el.play(); 
    }
    const pauseJs = (el) => {
        el.pause(); 
    }


    return {

        playVideo    : playVideo,

    }

}();

export default ControlVideos;